<template>
  <el-dialog
    width="600px"
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    class="default-dialog"
  >
    <div class="title">{{ title }}</div>
    <div class="file_flex">
      <div class="must mr10">文件上传：</div>
      <el-upload
        class="upload-demo"
        action=""
        :auto-upload="false"
        drag
        accept=".xls,.xlsx"
        :on-change="handleChange"
        :file-list="files"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </div>
    <div class="footer acc_flex">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" class="submit" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {importPayExcell,importStaffExcell} from '@/api'
export default {
  computed:{
  cid(){
        return sessionStorage.getItem('cid')
    }
  },
  props:{
    yearPeriod:{
      type:String|Number,
      default:''
    }
  },
  data() {
    return {
      files: [],
      title: "",
      visible: false,
    };
  },
  methods: {
    handleChange(file, fileList) {
      this.files = [];
      this.files.push(file);
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是 xls、xlsx格式!",
          type: "error",
        });
        this.files = [];
        return false;
      }
    },
    openTask(title) {
      this.visible = true;
      this.files = []
      this.title = title;
    },
    async confirm() {
      if (!this.files.length) {
        this.$message.error("请选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.files[0].raw);
      if(this.title == '工资表'){
        formData.append("yearPeriod", this.yearPeriod);
      }
      formData.append('cid',this.cid)
      const { data } = this.title == '工资表'?await importPayExcell(formData):await importStaffExcell(formData)
      if (data.code == 1) {
        this.$message.success(data.msg);
        this.visible = false;
        this.$emit("refresh");
      }
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.file_flex {
  display: flex;
  align-items: flex-start;
  column-gap: 10px;
}
.title {
  margin-bottom: 30px;
  font-size: 24px;
  color: #333333;
  font-weight: 500;
  text-align: center;
}
.footer {
  margin-top: 44px;
  justify-content: center;
  /deep/ .el-button {
    width: 100px;
  }
  .submit {
    color: #fff;
    margin-left: 20px;
    background: #269d7b;
  }
}
/deep/ .el-dialog__header,
/deep/ .el-dialog__footer {
  display: none;
}
/deep/ .el-dialog__body {
  padding: 30px 40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/salary/components/ImportExcell.vue